module.exports = __webpack_public_path__ + "static/img/mzxz1.8d8482e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/mzxz1.png
// module id = z3mZ
// module chunks = 55